import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { REVISIONES } from './types';

export const buscarRevisiones = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/revisiones/listar`, body, config);
        await dispatch({ type: REVISIONES.BUSCAR, payload: res.data.revisiones });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const informacionRevision = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/revisiones/informacion`, body, config);
        await dispatch({ type: REVISIONES.INFORMACION, payload: res.data.revision });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const confirmarRevision = (id, observaciones) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id, observaciones });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/revisiones/revisar`, body, config);
        await dispatch({ type: REVISIONES.CONFIRMAR, payload: res.data.revision });
        await dispatch(setAlert(res.data.msg || 'Revisión confirmada correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarRevision = () => dispatch => {
    dispatch({ type: REVISIONES.LIMPIAR });
};
